
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/wixData/components/collectionsList/actionButtons.scss.css.virtualfile';
        module.exports = {"buttonContainer":"_buttonContainer_rl8r3_7"};